module.exports = __webpack_public_path__ + "1-24.png?8371bf67f30f1e9a63bd067eddb1a95d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-24.png
// module id = 101
// module chunks = 0